import React from "react";
import "./Footer.css";
import versarLogo from "../assets/images/versar-logo-white.svg";
import geodesxLogo from "../assets/images/geodesx-logo-white.svg";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-logos">
        <div></div>
        <div>
          <img src={versarLogo} alt="Versar" width="100%" />
        </div>
        <div>
          <img src={geodesxLogo} alt="GEODESX" width="100%" />
        </div>
        <div></div>
      </div>
      <div className="footer-copyright">
        <p>© Copyright 2025 Versar Global Solutions, All rights reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
